<template>
  <div class="main-layout welcome-datainit-setting-page">
    <el-card class="box-outter">
      <c-title slot="header" title="现场迎新事项设置" :back="false"></c-title>
      <el-card class="box-table box-inner" shadow="never">
        <div slot="header">
          <div class="btn-group">
            <!-- 操作按钮 -->
            <div class="btn-left">
              <div class="opt-btn" title="新增" @click="goto('')">
                <i class="iconfont icon-add"></i>
              </div>
            </div>
            <!-- 右侧操作按钮 -->
            <table-btns
              :tableColumns="tableColumns"
              @tableColumnsChange="tableColumnsChange"
              @refresh="pageGet(true)"
            ></table-btns>
          </div>
        </div>

        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          @edit="goto"
          @delete="pageDel"
          v-loading="pageLoading"
        >
        </c-table>
      </el-card>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
          >
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/setting";
let mPage = MPage({
  pagePath: "/welcome-live/link/listPage",
  pageDelPath: "/welcome-live/link",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/welcome-live/link",
  handleInsertPath: "/welcome-live/link/save",
  handleUpdatePath: "/welcome-live/link/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  data() {
    let { tableColumns, formItems, formRules } = Configs(this);
    return {
      isFold: false,
      tableColumns,
      formItems,
      formRules,
      idList: [],
      title: "",
      dialogFormVisible: false,
      defaultHandleData: {
        linkName: "",
        description: "",
      },
    };
  },
  created() {
    this.handleData = Object.assign({}, this.defaultHandleData);
  },
  mounted() {},
  methods: {
    goto(data) {
      this.dialogFormVisible = true;
      this.handleData = Object.assign({}, this.defaultHandleData);
      let id = data.id;
      if (id) {
        this.handleGet(id);
        this.title = "编辑";
      } else {
        this.title = "新增";
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.$refs.cForm.resetFields();
    },
  },
};
</script>
<style lang="less">
.welcome-datainit-setting-page {
  .c-table .el-table .cell {
    height: auto !important;
    white-space: normal;
  }
}
</style>